import { useState, useRef, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { IoChevronDown, IoMicOutline } from "react-icons/io5";
import useTitanApp from "../../../hooks/useTitanApp";
import {
  setConsultationStarted,
  setShowStartConsultationModal,
  setShowConsultationTypeModal,
  updateConsultationStatus,
  setCurrentConsultationMediaButtonMode,
  updateConsultationTemplate,
  setIsSummaryStreaming,
  setIsSummaryGenerated,
  setDemDxSummary,
  setPatientSummary,
  setPatientTranscription,
  setPatientNotes,
  setTranscript,
  setConsultationPaused,
  setConsultationStopAfterRefresh,
  setShowPlayPauseBtn,
  setFreeTypeMode,
  setSelectedPatientConsultation,
  updateConsultationButtonStatus,
  setIsLocallyCompleted,
  setIsCallStarted,
  trackServiceBilling,
  sendMessageToMesh,
  addNhsServiceClaim,
  setisManualSubmited,
  getPatientConsultationByConsultationId,
  setSnomedCodes,
  setShowPathwayCompletionModal,
} from "../../../dispatchers/patientDispatchers";
import {
  setHydratedTemplateSections,
  setAiqa,
  setStreamedText,
  setSelectedTemplate,
  setIsTemplateSelected,
  sendAIQAService,
  setTranscriptionState,
} from "../../../dispatchers/templateDispatchers";
import { RxPencil1 } from "react-icons/rx";
import { LuPenTool } from "react-icons/lu";
import { RiArrowGoBackLine } from "react-icons/ri";

import { ActionTrackForConsultations } from "../../../data/actionTrackConsultations";
import { Check, CheckCircle, Trash } from "lucide-react";
import { FaCheck } from "react-icons/fa6";

import { useNavigate } from "react-router";
import { TranscribingButton } from "./TranscribingButton";
import { FaCircle } from "react-icons/fa";
import { ConsultationButtonStatus } from "../../../enum/ConsultationButtonStatus";
import { ReferralOutcomes } from "../../../enum/PossibleOutcomes";
import { FiTrash2 } from "react-icons/fi";
import { logEvent } from "../../../utils/GAUtils";
import { Button } from "../../ui/button";
import { setConsultationLoadError } from "../../../dispatchers/appDispatchers";
import { trackFirstTimeIntercomEvent } from "@/utils/trackFirstTimeIntercomEvent";

import { genderTypes } from "../../../enum/genderTypes";
import {
  nhs111TemplateId,
  nhsContraceptionTemplateId,
  nhsSinusitisTemplateId,
  nhsSoreThroatTemplateId,
  nhsImpetigoTemplateId,
  nhsInsectBitesTemplateId,
  nhsShinglesTemplateId,
  nhsUtiTemplateId,
  nhsAomTemplateId,
  nhsHypertensionStage1TemplateId,
  nhsHypertensionABPMFittingTemplateId,
  nhsHypertensionABPMFollowupTemplateId,
  nhsAhtWeightTemplateId,
  nhsAhtFollowUpTemplateId,
  nhsAhtSixMonthTemplateId,
  nhsAhtTravelHealthTemplateId,
} from "../../../data/constantStrings";
import { completeConsultationHistory } from "../../../dispatchers/treatmentPlanDispatchers";
import {
  getNhsServiceName,
  getNhsServiceId,
  isNhsService,
  isAhtService,
} from "@/components/nhs-templates/NHSServicesHelper";
import { getNhs111EmergencySupplyFormData } from "@/components/nhs-templates/UseNhs111EmergencySupplyFormData";
export default function PatientConsultationMediaButton({
  stopTranscription,
  isConsultationStopped,
  setIsConsultationStopped,
  elapsedTime,
}) {
  const [showCompletionModal, setShowCompletionModal] = useState(false);
  const [
    appointmentActionsConfirmed,
    setAppointmentActionsConfirmed,
  ] = useState(false);
  const [draftLossConfirmed, setDraftLossConfirmed] = useState(false);

  const { patientState, appState, templateState } = useTitanApp();
  const {
    darkMode,
    currentUser,
    currentPharmacy,
    currentPharmacyId,
    companyId,
    company,
  } = appState || {};
  const {
    consultationStarted,
    isSummaryStreaming,
    isSummaryGenerated,
    selectedPatientConsultation,
    isDemDxActive,
    demDxSummary,
    consultationId,
    selectedPatientDetails,
    consultationEnded,
    consultationMediaButtonMode,
    consultationPaused,
    freeTypeMode,
    isLocallyCompleted,
    transcript,
    preConsultationTranscription,
    nhs111FormData,
    consultationData,
    nhsContraceptionFormData,
    nhsSinusitisFormData,
    nhsSoreThroatFormData,
    nhsUtiFormData,
    nhsImpetigoFormData,
    nhsInsectBitesFormData,
    nhsShinglesFormData,
    nhsAomFormData,
    showPathwayCompletionModal,
    hypertensionABPMFollowupFormData,
    hypertensionInitialFormData,
    hypertensionABPMFittingFormData,
    nhsAhtFormData,
  } = patientState || {};
  const pharmacyFirstTemplateMap = {
    [nhsSinusitisTemplateId]: nhsSinusitisFormData,
    [nhsSoreThroatTemplateId]: nhsSoreThroatFormData,
    [nhsUtiTemplateId]: nhsUtiFormData,
    [nhsImpetigoTemplateId]: nhsImpetigoFormData,
    [nhsInsectBitesTemplateId]: nhsInsectBitesFormData,
    [nhsShinglesTemplateId]: nhsShinglesFormData,
    [nhsAomTemplateId]: nhsAomFormData,
    [nhsHypertensionStage1TemplateId]: hypertensionInitialFormData,
    [nhsHypertensionABPMFittingTemplateId]: hypertensionABPMFittingFormData,
    [nhsHypertensionABPMFollowupTemplateId]: hypertensionABPMFollowupFormData,
    [nhs111TemplateId]: nhs111FormData,
    [nhsContraceptionTemplateId]: nhsContraceptionFormData,
    [nhsAhtWeightTemplateId]: nhsAhtFormData,
    [nhsAhtTravelHealthTemplateId]: true,
  };
  const { isTemplateSelected, hydratedTemplateSections } = templateState || {};

  const allUserControls = Array.isArray(
    hydratedTemplateSections?.templateSections,
  )
    ? hydratedTemplateSections?.templateSections.flatMap(
        (section) => section.userControls || [],
      )
    : [];
  const questions = Array.isArray(allUserControls)
    ? allUserControls?.map((ctrl, idx) => ({ [`q${idx + 1}`]: ctrl.label }))
    : [];

  const [showDropdown, setShowDropdown] = useState(false);
  const manualClass =
    consultationMediaButtonMode === "manual" ? " manual-mode" : "";

  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  const hasAnsweredQuestions = () => {
    if (
      !hydratedTemplateSections ||
      !Array.isArray(hydratedTemplateSections.templateSections)
    ) {
      return false;
    }

    return hydratedTemplateSections.templateSections.some(
      (section) =>
        Array.isArray(section.userControls) &&
        section.userControls.some(
          (control) => control.value && control.value.trim() !== "",
        ),
    );
  };

  useEffect(() => {
    if (
      selectedPatientConsultation?.consultationButtonStatus !==
      ConsultationButtonStatus.Manual
    )
      setCurrentConsultationMediaButtonMode("transcription");
  }, []);

  useEffect(() => {
    if (showPathwayCompletionModal) {
      setShowCompletionModal(true);
      setShowPathwayCompletionModal(false);
    }
  }, [showPathwayCompletionModal]);

  const handleStartConsultation = async () => {
    if (
      (!isTemplateSelected && selectedPatientConsultation === null) ||
      showDropdown ||
      isSummaryStreaming
    )
      return;

    if (consultationStarted || consultationPaused) {
      stopTranscription();
      setIsConsultationStopped(true);
      setConsultationStarted(false);
      setFreeTypeMode(false);

      await ActionTrackForConsultations(
        1,
        currentUser,
        currentPharmacy,
        company,
      );
    } else {
      setShowStartConsultationModal(true);
    }
  };

  const toText = (value) =>
    Array.isArray(value)
      ? value.filter(Boolean).join("\n")
      : value
      ? String(value)
      : "";

  const getOptionLabel = (options, value) => {
    if (!value) return "";
    return options?.find((option) => option.value === value)?.label || value;
  };

  const buildPatientMeshFields = () => ({
    patientNhsNumber: selectedPatientDetails?.nhsNumber || "",
    patientGivenName: selectedPatientDetails?.foreName || "",
    patientFamilyName: selectedPatientDetails?.surName || "",
    patientGender: genderTypes[selectedPatientDetails?.sex] || "Not Known",
    patientDateOfBirth: selectedPatientDetails?.dob
      ? String(selectedPatientDetails.dob)
      : "",
    authorTime: new Date().toISOString(),
  });

  const mapPharmacyFirstAuditToMesh = (formData) => {
    const finalOutcome = formData?.finalOutcome;
    const pathwayName = formData?.pathwayName || formData?.pathwayId || "";
    const safetyNettingText = toText(finalOutcome?.safetyNetting);

    if (!finalOutcome) return null;

    return {
      ...buildPatientMeshFields(),
      outcomeTitle: finalOutcome.title || "",
      outcomeText: finalOutcome.reason || finalOutcome.title || "",
      symptomsTitle: pathwayName,
      symptomsText: pathwayName,
      safetyNetAdviceTitle: safetyNettingText ? "Safety netting advice" : "",
      safetyNetAdviceText: safetyNettingText,
    };
  };

  const mapNhs111ToMesh = (formData) => {
    if (!formData) return null;

    const serviceName =
      getNhsServiceName(selectedPatientConsultation?.templateId) ||
      "NHS 111 Emergency Supply";
    const template = getNhs111EmergencySupplyFormData();
    const outcomeText =
      formData.outcomes === "other"
        ? formData.outcomesOther
        : getOptionLabel(template.selectOptions.outcomes, formData.outcomes);
    const reasonForRequest =
      formData.reasonForRequest === "other"
        ? formData.reasonForRequestOther
        : getOptionLabel(
            template.selectOptions.reasonsForRequest,
            formData.reasonForRequest,
          );
    const adviceProvidedTo = getOptionLabel(
      template.selectOptions.adviceProvidedToOptions,
      formData.adviceProvidedTo,
    );
    const safetyNetAdviceText = [
      adviceProvidedTo && `Provided to: ${adviceProvidedTo}`,
      formData.planAndRequestedActions,
    ]
      .filter(Boolean)
      .join("\n");

    return {
      ...buildPatientMeshFields(),
      outcomeTitle: serviceName,
      outcomeText:
        outcomeText ||
        formData.planAndRequestedActions ||
        formData.internalNotes ||
        "",
      symptomsTitle: serviceName,
      symptomsText: reasonForRequest || "",
      safetyNetAdviceTitle: safetyNetAdviceText ? "Advice given" : "",
      safetyNetAdviceText,
    };
  };

  const mapNhsFormToMesh = (formData) => {
    if (!formData) return null;

    const serviceName =
      getNhsServiceName(selectedPatientConsultation?.templateId) ||
      "NHS Consultation";
    const outcomeTitle =
      formData.outcomesOther ||
      formData.outcomes ||
      formData.outcomeNotes ||
      formData.outcome ||
      serviceName;

    return {
      ...buildPatientMeshFields(),
      outcomeTitle,
      outcomeText:
        formData.planAndRequestedActions ||
        formData.outcomeNotes ||
        formData.internalNotes ||
        outcomeTitle,
      symptomsTitle: serviceName,
      symptomsText:
        formData.ocServiceReason ||
        formData.oecServiceReason ||
        formData.referredFor ||
        serviceName,
      safetyNetAdviceTitle: formData.adviceGiven ? "Advice given" : "",
      safetyNetAdviceText: [
        formData.adviceProvidedTo &&
          `Provided to: ${formData.adviceProvidedTo}`,
        toText(formData.healthyLivingAdvice),
        formData.healthyLivingAdviceNotes,
        formData.planAndRequestedActions,
      ]
        .filter(Boolean)
        .join(", "),
    };
  };

  const generateMongoObjectId = () =>
    Array.from({ length: 24 }, () =>
      Math.floor(Math.random() * 16).toString(16),
    ).join("");

  const toIsoDate = (value, fallback = null) => {
    const dateValue = value || fallback;
    if (!dateValue) return null;

    const date = new Date(dateValue);
    return Number.isNaN(date.getTime()) ? null : date.toISOString();
  };

  const getPatientName = () =>
    selectedPatientDetails?.patientName ||
    selectedPatientConsultation?.patientName ||
    `${selectedPatientDetails?.foreName ||
      ""} ${selectedPatientDetails?.surName || ""}`.trim();

  const getPatientAddress = () =>
    [
      selectedPatientDetails?.address,
      selectedPatientDetails?.addressLine1,
      selectedPatientDetails?.addressLine2,
      selectedPatientDetails?.addressLine3,
      selectedPatientDetails?.addressLine4,
      selectedPatientDetails?.addressLine5,
      selectedPatientDetails?.postcode || selectedPatientDetails?.postCode,
    ]
      .filter(Boolean)
      .join(", ");

  const getPatientTelephoneNumber = () =>
    selectedPatientDetails?.telephoneNumber ||
    selectedPatientDetails?.telephone ||
    selectedPatientDetails?.mobile ||
    selectedPatientDetails?.contacts?.find((contact) => !!contact?.value)
      ?.value ||
    "";

  const buildNhsServiceClaimPayload = (templateId) => {
    const now = new Date().toISOString();
    const serviceName =
      getNhsServiceName(templateId) ||
      selectedPatientConsultation?.serviceName ||
      "NHS Consultation";
    const clinicalServiceId =
      selectedPatientConsultation?.clinicalServiceID ||
      selectedPatientConsultation?.clinicalServiceId ||
      consultationData?.clinicalServiceID ||
      consultationData?.clinicalServiceId ||
      consultationId;
    const serviceId =
      getNhsServiceId(templateId) ||
      selectedPatientConsultation?.serviceID ||
      selectedPatientConsultation?.serviceId ||
      consultationData?.serviceID ||
      consultationData?.serviceId ||
      "";
    const completedBy = currentUser?.fullName || currentUser?.name || "";
    const completedByEmail =
      currentUser?.emailAddress || currentUser?.email || "";
    const engagementDate =
      selectedPatientConsultation?.engagementDate ||
      selectedPatientConsultation?.createdOn ||
      selectedPatientConsultation?.createdAt ||
      consultationData?.engagementDate ||
      consultationData?.createdOn ||
      consultationData?.createdAt;

    return {
      _id: generateMongoObjectId(),
      ClinicalServiceID: clinicalServiceId || "",
      ServiceID: serviceId,
      ServiceName: serviceName,
      ServiceType: 1,
      PatientId:
        selectedPatientDetails?.patientID ||
        selectedPatientConsultation?.patientId ||
        "",
      PatientName: getPatientName(),
      TelephoneNumber: getPatientTelephoneNumber(),
      DOB: toIsoDate(selectedPatientDetails?.dob),
      NhsNumber:
        selectedPatientDetails?.nhsNumber ||
        selectedPatientConsultation?.nhsNumber ||
        "",
      Address: getPatientAddress(),
      DrugName: [],
      ServiceDate: now,
      EngagementDate: toIsoDate(engagementDate, now),
      InterventionDate: now,
      FollowUpDate: null,
      Status: 2,
      CompletedBy: completedBy,
      CompletedAt: now,
      CompletedByEmail: completedByEmail,
      SendToOrbit: false,
      IsClaimed: false,
      ClaimedBy: null,
      ClaimedAt: null,
      ClaimedEmailBy: null,
      CreatedOn: now,
      PharmacyID: currentPharmacyId,
      PrescriptionIncomingId: null,
      StageType: selectedPatientConsultation?.stageType || 3,
    };
  };

  const handleUpdateStatus = async () => {
    setDraftLossConfirmed(false);
    setAppointmentActionsConfirmed(false);
    const data = {
      consultationId: consultationId,
      actionStatus: 1,
    };

    try {
      logEvent("button_click", {
        event_category: "User Interaction",
        event_label: "Patient Consultation Complete",
        pharmacy_name: currentPharmacy.teamPharmacyName,
      });
      trackFirstTimeIntercomEvent({
        eventName: "consultation_completed_first_time",
        user: {
          id: currentUser.emailAddress,
          email: currentUser.emailAddress,
          name: currentUser.fullName,
        },
        properties: {
          source: "patient_consultation_media_button",
        },
      });
    } catch (error) {}
    await updateConsultationStatus(data);
    trackServiceBilling({
      companyId,
      consultationId,
      pharmacyId: currentPharmacyId,
      actiontype: "consultationStatus",
      consultationActionStatus: 1,
    });
    if (isNhsService(selectedPatientConsultation?.templateId)) {
      const meshMappers = {
        [nhsSinusitisTemplateId]: mapPharmacyFirstAuditToMesh,
        [nhsSoreThroatTemplateId]: mapPharmacyFirstAuditToMesh,
        [nhsUtiTemplateId]: mapPharmacyFirstAuditToMesh,
        [nhsImpetigoTemplateId]: mapPharmacyFirstAuditToMesh,
        [nhsInsectBitesTemplateId]: mapPharmacyFirstAuditToMesh,
        [nhsShinglesTemplateId]: mapPharmacyFirstAuditToMesh,
        [nhsAomTemplateId]: mapPharmacyFirstAuditToMesh,
        [nhs111TemplateId]: mapNhs111ToMesh,
        [nhsContraceptionTemplateId]: mapNhsFormToMesh,
        [nhsHypertensionStage1TemplateId]: mapNhsFormToMesh,
        [nhsHypertensionABPMFittingTemplateId]: mapNhsFormToMesh,
        [nhsHypertensionABPMFollowupTemplateId]: mapNhsFormToMesh,
        [nhsAhtWeightTemplateId]: mapPharmacyFirstAuditToMesh,
      };

      const templateId = selectedPatientConsultation?.templateId;
      const formData = pharmacyFirstTemplateMap[templateId];
      const mapToMesh = meshMappers[templateId];

      const nhsConsultation = mapToMesh?.(formData);

      if (nhsConsultation) {
        // await sendMessageToMesh({
        //   pharmacyId: currentPharmacyId,
        //   patientId: selectedPatientDetails?.patientID,
        //   consultationId: consultationId,
        //   nhsConsultation,
        // });
      }
      const claimPayload = buildNhsServiceClaimPayload(templateId);
      // await addNhsServiceClaim(claimPayload); temprorily disabled until we have a better way to handle claims for NHS services
    }

    await completeConsultationHistory(consultationId);
    navigate(
      `/pharmacy/patientdashboard-v2/${currentPharmacy.teamPharmacyID}/${selectedPatientDetails?.patientID}`,
    );
    setShowCompletionModal(false);
  };

  const actions = [
    "Save all consultation notes and recordings",
    "Generate consultation summary",
    "Update patient records",
    "Send notifications if configured",
  ];

  useEffect(() => {
    if (isSummaryGenerated) {
      setIsConsultationStopped(false);
    }
  }, [isSummaryGenerated]);

  const handleDropdownClick = async (action) => {
    try {
      switch (action) {
        case 2:
          setShowConsultationTypeModal(true);
          setCurrentConsultationMediaButtonMode("free");
          break;
        case 3:
          setisManualSubmited(true);
          setCurrentConsultationMediaButtonMode("manual");
          const data = {
            consultationId: consultationId,
            buttonStatus: ConsultationButtonStatus.Manual,
          };
          await updateConsultationButtonStatus(data);

          if (preConsultationTranscription) {
            const initialData = {
              q: questions,
              t: preConsultationTranscription,
            };
            try {
              await sendAIQAService(initialData);
            } catch (err) {
              console.error("Error sending pre-consult AI service:", err);
            }
          }

          setShowDropdown(false);
          return;

        default:
          break;
      }

      setShowDropdown(false);
    } catch (error) {
      console.error("Error handling dropdown action:", error);
      setConsultationLoadError(true);
      setShowDropdown(false);
    }
  };

  const handleClearManualEntryValues = async () => {
    try {
      const data = {
        consultationId: consultationId,
        buttonStatus: ConsultationButtonStatus.InProgress,
      };
      await updateConsultationButtonStatus(data);

      await updateConsultationTemplate({
        consultationId,
        payload: [],
      });

      setHydratedTemplateSections(null);
      setSelectedTemplate(null);
      setTranscript("");
      setIsTemplateSelected(false);
      setSelectedPatientConsultation(null);
    } catch (error) {
      console.error("Error clearing manual entry values:", error);
      setConsultationLoadError(true);
    }
  };

  const handleStopManualEntry = async (e) => {
    e.stopPropagation();

    const hasAnswers = hasAnsweredQuestions();

    if (!hasAnswers) return;
    if (isLocallyCompleted) {
      setShowCompletionModal(true);
      return;
    }

    setIsSummaryStreaming(true);
    stopTranscription();
    setCurrentConsultationMediaButtonMode("transcription");
    handleUpdateButtonStatus();
  };

  const handleCancelCompleteConsultation = async () => {
    try {
      setAiqa([] || null);
      setCurrentConsultationMediaButtonMode("transcription");
      setShowCompletionModal(false);
      setIsConsultationStopped(false);
      setShowDropdown(false);
      setConsultationStarted(false);
      setShowStartConsultationModal(false);
      setShowConsultationTypeModal(false);
      setConsultationPaused(false);
      setIsTemplateSelected(false);
      setIsSummaryStreaming(false);
      setIsSummaryGenerated(false);
      setPatientTranscription("");
      setDemDxSummary("");
      setPatientSummary("");
      setHydratedTemplateSections(null);
      setSelectedTemplate(null);
      setPatientNotes("");
      setStreamedText("");
      setSnomedCodes([]);
      setTranscript("");
      stopTranscription(true);
      setShowPlayPauseBtn(false);
      setSelectedPatientConsultation(null);
      setTranscriptionState("idle");
      const data = {
        consultationId: consultationId,
        buttonStatus: ConsultationButtonStatus.InProgress,
      };
      await updateConsultationButtonStatus(data);
      await updateConsultationTemplate({
        consultationId,
        payload: [],
      });
    } catch (error) {
      console.error("Error cancelling complete consultation:", error);
      setConsultationLoadError(true);
    }
  };

  const handleCancelManualEntry = () => {
    setCurrentConsultationMediaButtonMode("transcription");
    handleClearManualEntryValues();
    setShowDropdown(false);
  };
  const nhsTemplateFormData =
    pharmacyFirstTemplateMap[selectedPatientConsultation?.templateId];
  // The completed pathway's own verdict, shown at the top of the Complete
  // Consultation modal so the pharmacist signs off against the outcome rather
  // than against a bare confirmation. Kept to the AHT weight template, whose
  // audit in redux is re-pointed at the open consultation — the other
  // pharmacy-first form slots are not, so an outcome card there could be a
  // leftover from the last consultation.
  const ahtAudit: any =
    selectedPatientConsultation?.templateId === nhsAhtWeightTemplateId
      ? nhsAhtFormData
      : null;
  const completedOutcome = ahtAudit?.finalOutcome
    ? {
        title: ahtAudit.finalOutcome.title as string,
        reason: ahtAudit.finalOutcome.reason as string | undefined,
        outcomeType: (ahtAudit.finalOutcome.outcomeType ?? "") as string,
        pathwayName:
          (ahtAudit.pathwayName as string) ||
          getNhsServiceName(selectedPatientConsultation?.templateId) ||
          "",
      }
    : null;
  const isNhsBlocked =
    isNhsService(selectedPatientConsultation?.templateId) &&
    selectedPatientConsultation?.consultationStatus === 2;
  const isAhtBlocked =
    isAhtService(selectedPatientConsultation?.templateId) &&
    selectedPatientConsultation?.consultationStatus !== 6 &&
    !nhsTemplateFormData;
  const handleUpdateButtonStatus = async () => {
    var consultationData = await getPatientConsultationByConsultationId(
      consultationId,
    );
    try {
      const data = {
        consultationId: consultationId,
        buttonStatus: ConsultationButtonStatus.Completed,
      };
      const success = await updateConsultationButtonStatus(data);
      trackServiceBilling({
        companyId,
        consultationId,
        pharmacyId: currentPharmacyId,
        actiontype: "ManualEntry",
      });

      if (success) {
        // this is to show instantly show CompleteConsultationButton while on start new consultation
        setIsLocallyCompleted(true);
      }
    } catch (error) {
      console.error("Error updating button status:", error);
      setConsultationLoadError(true);
    }
  };

  const handleStopTranscribing = async () => {
    const data = {
      consultationId: consultationId,
      actionStatus: 2,
    };
    await updateConsultationStatus(data);
    if (selectedPatientConsultation) {
      setConsultationStopAfterRefresh(true);
    }
    setShowPlayPauseBtn(false);

    stopTranscription();

    setIsConsultationStopped(true);
    setConsultationPaused(false);
  };

  const handleUpdateButtonStatusOnTranscribing = async () => {
    try {
      const data = {
        consultationId: consultationId,
        buttonStatus: ConsultationButtonStatus.Completed,
      };

      if (transcript !== "") {
        const success = await updateConsultationButtonStatus(data);

        if (success) {
          setIsLocallyCompleted(true);
          const endTime = new Date().toISOString();
          trackServiceBilling({
            companyId,
            consultationId,
            pharmacyId: currentPharmacyId,
            endedAt: endTime,
            actiontype: "transcriptionend",
          });
        }
      }
    } catch (error) {
      console.error("Error updating button status on transcribing:", error);
      setConsultationLoadError(true);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const RightChevron = () => (
    <div
      className={`right-icon ${consultationStarted ? "playing" : "stopped"}`}
      onClick={(e) => {
        e.stopPropagation(); // prevent parent click
        setShowDropdown((prev) => !prev); // always toggle
      }}
    >
      <IoChevronDown size={14} color={"#f2f2f2"} />
    </div>
  );

  const StartButton = () => (
    <>
      <div>
        <IoMicOutline color="#fff" size={15} />
      </div>
      <div className="text-wrapper">
        <p>Start Transcribing</p>
      </div>
      <RightChevron />
    </>
  );

  const StopButton = () => (
    <Button
      className="d-flex bg-[#e90431] hover:bg-[#ab0224ff] "
      onClick={() => handleUpdateButtonStatus()}
    >
      <div className="icon-cont " style={{ marginRight: "3px" }}>
        <FaCircle color="#fff" size={2} />
      </div>
      <div className="text-wrapper">
        <p>Stop Transcribing</p>
      </div>
    </Button>
  );

  const StopManualEntryButton = () => (
    <div className="d-flex">
      <div className="icon-cont " style={{ marginRight: "3px" }}>
        <LuPenTool size={18} />
      </div>
      <div className="text-wrapper">
        <p
          initial={{ opacity: 1, y: 0 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3 }}
        >
          Finish Manual Entry
        </p>
        <RightChevron />
      </div>
    </div>
  );

  const CompletingButton = () => (
    <>
      <div className="icon-cont">
        <FaCheck color="#fff" size={16} />
      </div>

      <div className="text-wrapper">
        <p className="transcribing-text">Completing...</p>
      </div>
    </>
  );

  const CompleteConsultationButton = () => (
    <div className="d-flex" onClick={() => handleUpdateButtonStatus()}>
      <div className="icon-cont " style={{ marginRight: "3px" }}>
        <CheckCircle color="#fff" size={18} />
      </div>

      <div className="text-wrapper">
        <p className="transcribing-text">Complete Consultation</p>
      </div>
    </div>
  );
  const deleteActiveConsultation = async () => {
    try {
      const data = {
        consultationId: consultationId,
        buttonStatus: ConsultationButtonStatus.Cancel,
      };
      const res = await updateConsultationButtonStatus(data);
      trackServiceBilling({
        companyId,
        consultationId,
        pharmacyId: currentPharmacyId,
        actiontype: "consultationStatus",
        consultationActionStatus: 5,
      });
      if (res === true) {
        navigate(
          `/pharmacy/patientdashboard-v2/${currentPharmacy.teamPharmacyID}/${selectedPatientDetails?.patientID}`,
        );
      }
    } catch (error) {
      console.error("Error deleting active consultation:", error);
      setConsultationLoadError(true);
    }
  };
  const isTravelHealthConsultation =
    selectedPatientConsultation?.templateId === nhsAhtTravelHealthTemplateId;
  const draftActionNumbers = ["11", "12"];
  const hasDrafts =
    !isTravelHealthConsultation &&
    (consultationData?.actions || []).some((a) =>
      draftActionNumbers.includes(a.actionNumber),
    );

  const consultationActions =
    consultationData?.template?.consultationActions || [];

  const enabledActions = (consultationActions || []).filter(
    (action) => action.enabled !== false,
  );

  const disabledActions = (consultationActions || []).filter(
    (action) => action.enabled === false,
  );

  let totalTasks = 0;
  let incompleteTasks = 0;

  const hasReduxTaskData = consultationId
    ? consultationId in (patientState?.completedTasksByConsultation ?? {})
    : false;
  const reduxCompletedLabels: string[] = consultationId
    ? patientState?.completedTasksByConsultation?.[consultationId] ?? []
    : [];

  (consultationData?.actions || []).forEach((action) => {
    try {
      // Count tasks (actionNumber "14") ONLY
      if (action?.actionNumber === "14") {
        const payload =
          typeof action.payload === "string"
            ? JSON.parse(action.payload)
            : action.payload;
        const tasks = payload?.tasks || [];
        totalTasks += tasks.length;

        if (hasReduxTaskData) {
          incompleteTasks += tasks.filter(
            (t) => !reduxCompletedLabels.includes(t.label),
          ).length;
        } else {
          incompleteTasks += tasks.filter((t) => t.completed !== true).length;
        }
      }
    } catch (e) {}
  });

  // Total = template actions + tasks from actionNumber "14"
  // Outstanding = disabled template actions + incomplete tasks
  const total = consultationActions.length + totalTasks;
  const outstandingActions = disabledActions.length + incompleteTasks;
  const hasOutstandingActions = outstandingActions > 0;
  const isCompleteDisabled =
    (hasOutstandingActions && !appointmentActionsConfirmed) ||
    (hasDrafts && !draftLossConfirmed);

  return (
    <div
      className={`pc-media-btn ${
        isSummaryStreaming
          ? "completing"
          : isLocallyCompleted ||
            demDxSummary !== "" ||
            selectedPatientConsultation?.consultationButtonStatus ===
              ConsultationButtonStatus.Completed
          ? "complete"
          : consultationMediaButtonMode !== "transcription" &&
            (consultationMediaButtonMode === "manual" ||
              selectedPatientConsultation?.consultationButtonStatus ===
                ConsultationButtonStatus.Manual)
          ? "manual-mode"
          : consultationStarted
          ? "transcribing"
          : consultationPaused && transcript !== ""
          ? "stop"
          : "start"
      }
    ${
      selectedPatientConsultation?.consultationStatus === 1 ||
      !isTemplateSelected ||
      isDemDxActive
        ? "disabled"
        : ""
    }${manualClass}`}
      style={{
        pointerEvents:
          isSummaryStreaming || isNhsBlocked || isAhtBlocked ? "none" : "auto",
        opacity: isSummaryStreaming || isNhsBlocked || isAhtBlocked ? 0.6 : 1,
        cursor:
          isSummaryStreaming || isNhsBlocked || isAhtBlocked
            ? "not-allowed"
            : "pointer",
      }}
      onClick={(e) => {
        if (isSummaryStreaming) return;
        if (
          consultationMediaButtonMode === "manual" ||
          selectedPatientConsultation?.consultationButtonStatus ===
            ConsultationButtonStatus.Manual
        ) {
          handleStopManualEntry(e);
          return;
        }

        if (consultationPaused) {
          handleStopTranscribing();
          return;
        }

        if (
          isLocallyCompleted ||
          demDxSummary !== "" ||
          selectedPatientConsultation?.consultationButtonStatus ===
            ConsultationButtonStatus.Completed ||
          (isAhtService(selectedPatientConsultation?.templateId) &&
            !!nhsTemplateFormData) ||
          (isNhsService(selectedPatientConsultation?.templateId) &&
            nhsTemplateFormData &&
            typeof nhsTemplateFormData === "object")
        ) {
          setShowCompletionModal(true);
          return;
        }

        handleStartConsultation();
      }}
      ref={dropdownRef}
    >
      {isSummaryStreaming ? (
        <CompletingButton />
      ) : (isLocallyCompleted ||
          demDxSummary !== "" ||
          selectedPatientConsultation?.consultationButtonStatus ===
            ConsultationButtonStatus.Completed ||
          (isAhtService(selectedPatientConsultation?.templateId) &&
            !!nhsTemplateFormData) ||
          (isNhsService(selectedPatientConsultation?.templateId) &&
            nhsTemplateFormData &&
            typeof nhsTemplateFormData === "object")) &&
        !isSummaryStreaming ? (
        <CompleteConsultationButton />
      ) : consultationMediaButtonMode !== "transcription" &&
        (consultationMediaButtonMode === "manual" ||
          selectedPatientConsultation?.consultationButtonStatus ===
            ConsultationButtonStatus.Manual) ? (
        <StopManualEntryButton />
      ) : consultationStarted ? (
        <TranscribingButton
          showDropdown={showDropdown}
          setShowDropdown={setShowDropdown}
          handleUpdateButtonStatus={handleUpdateButtonStatusOnTranscribing}
          elapsedTime={elapsedTime}
        />
      ) : consultationPaused && transcript !== "" ? (
        <StopButton />
      ) : consultationMediaButtonMode === "transcription" ||
        consultationMediaButtonMode === "free" ||
        !selectedPatientConsultation ||
        selectedPatientConsultation?.consultationButtonStatus ===
          ConsultationButtonStatus.InProgress ? (
        <StartButton />
      ) : (
        <></>
      )}

      <AnimatePresence>
        {showDropdown && (
          <motion.div
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.2 }}
            whileHover={{ scale: 1.02 }}
            className="transcription-dropdown"
          >
            {/* <div
              onClick={() => handleDropdownClick(1)}
              className="dropdown-item"
            >
              <MdOutlineFileUpload size={20} />
              Upload transcription audio file
            </div> */}
            {consultationMediaButtonMode !== "transcription" &&
            (consultationMediaButtonMode === "manual" ||
              selectedPatientConsultation?.consultationButtonStatus ===
                ConsultationButtonStatus.Manual) ? (
              <>
                <div
                  onClick={(e) => {
                    e.stopPropagation();
                    handleCancelManualEntry();
                  }}
                  className="dropdown-item"
                >
                  <RiArrowGoBackLine size={18} />
                  <p className="pc-consultation-media-button-dropdown-item-text">
                    Cancel manual entry
                  </p>
                </div>
              </>
            ) : consultationStarted &&
              consultationMediaButtonMode === "transcription" ? (
              <>
                <div
                  onClick={(e) => {
                    e.stopPropagation();
                    handleCancelCompleteConsultation();
                  }}
                  className="dropdown-item"
                >
                  <RiArrowGoBackLine size={18} />
                  <p className="pc-consultation-media-button-dropdown-item-text">
                    Cancel transcription
                  </p>
                </div>
              </>
            ) : (
              (!selectedPatientConsultation ||
                consultationMediaButtonMode === "transcription" ||
                consultationMediaButtonMode === "free" ||
                selectedPatientConsultation?.consultationButtonStatus ===
                  ConsultationButtonStatus.InProgress) && (
                <>
                  <div
                    onClick={(e) => {
                      e.stopPropagation();
                      handleDropdownClick(2);
                    }}
                    className="dropdown-item"
                  >
                    <RxPencil1 size={20} />
                    <p className="pc-consultation-media-button-dropdown-item-text">
                      Free type transcription{" "}
                    </p>
                  </div>
                  <div
                    onClick={(e) => {
                      e.stopPropagation();
                      handleDropdownClick(3);
                    }}
                    className="dropdown-item"
                  >
                    <LuPenTool color={darkMode ? "#fff" : "#000"} size={18} />
                    <p className="pc-consultation-media-button-dropdown-item-text">
                      {" "}
                      Manual Entry
                    </p>
                  </div>
                </>
              )
            )}
          </motion.div>
        )}
      </AnimatePresence>
      <AnimatePresence>
        {showCompletionModal && (
          <motion.div
            className={`completion-modal ${darkMode ? "dark" : "light"}`}
            style={{ pointerEvents: "auto" }}
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.95 }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="completion-modal-content">
              <button
                className="completion-modal-close"
                onClick={() => {
                  setShowCompletionModal(false);
                }}
              >
                ×
              </button>

              <div className="flex items-center gap-2">
                <Check
                  className={`w-5 h-5 transition-colors duration-300 ${
                    darkMode ? "text-blue-400" : "text-blue-600"
                  }`}
                />
                <h2 className="flex items-center gap-2 text-lg font-semibold leading-none tracking-tight">
                  Complete Consultation
                </h2>
              </div>
              {completedOutcome &&
                (() => {
                  const ot = completedOutcome.outcomeType;
                  const styles =
                    ot === "supply"
                      ? {
                          bg: darkMode
                            ? "bg-green-900/30 border-green-700"
                            : "bg-green-50 border-green-200",
                          label: darkMode ? "text-green-300" : "text-green-700",
                          title: darkMode ? "text-green-100" : "text-green-900",
                          body: darkMode ? "text-green-200" : "text-green-800",
                        }
                      : ot === "refer_urgent" || ot === "emergency"
                        ? {
                            bg: darkMode
                              ? "bg-red-900/30 border-red-700"
                              : "bg-red-50 border-red-200",
                            label: darkMode ? "text-red-300" : "text-red-700",
                            title: darkMode ? "text-red-100" : "text-red-900",
                            body: darkMode ? "text-red-200" : "text-red-800",
                          }
                        : ot.startsWith("refer") || ot === "cannot_supply"
                          ? {
                              bg: darkMode
                                ? "bg-amber-900/30 border-amber-700"
                                : "bg-amber-50 border-amber-200",
                              label: darkMode
                                ? "text-amber-300"
                                : "text-amber-700",
                              title: darkMode
                                ? "text-amber-100"
                                : "text-amber-900",
                              body: darkMode
                                ? "text-amber-200"
                                : "text-amber-800",
                            }
                          : {
                              bg: darkMode
                                ? "bg-blue-900/30 border-blue-700"
                                : "bg-blue-50 border-blue-200",
                              label: darkMode
                                ? "text-blue-300"
                                : "text-blue-700",
                              title: darkMode
                                ? "text-blue-100"
                                : "text-blue-900",
                              body: darkMode ? "text-blue-200" : "text-blue-800",
                            };
                  const prettyType = ot
                    .replace(/_/g, " ")
                    .replace(/\b\w/g, (c) => c.toUpperCase());
                  return (
                    <div className={`mt-4 rounded-lg p-3 border ${styles.bg}`}>
                      <p
                        className={`text-[11px] uppercase tracking-wide font-semibold ${styles.label}`}
                      >
                        Outcome
                        {prettyType ? ` · ${prettyType}` : ""}
                        {completedOutcome.pathwayName
                          ? ` · ${completedOutcome.pathwayName}`
                          : ""}
                      </p>
                      <p className={`text-sm font-semibold mt-1 ${styles.title}`}>
                        {completedOutcome.title}
                      </p>
                      {completedOutcome.reason && (
                        <p className={`text-xs mt-1 ${styles.body}`}>
                          {completedOutcome.reason}
                        </p>
                      )}
                    </div>
                  );
                })()}
              <p
                className={`my-4 text-sm transition-colors duration-300 ${
                  darkMode ? "text-gray-300" : "text-gray-600"
                }`}
              >
                Are you sure you want to complete this consultation? This action
                will:
              </p>
              <ul
                className={`space-y-2 text-sm transition-colors duration-300 ${
                  darkMode ? "text-gray-300" : "text-gray-600"
                }`}
              >
                {actions.map((action, index) => (
                  <li key={index} className="flex items-center gap-2">
                    <Check
                      color="green"
                      className={`w-4 h-4 transition-colors duration-300 ${
                        darkMode ? "text-green-400" : "text-green-600"
                      }`}
                    />
                    {action}
                  </li>
                ))}
              </ul>

              <div className="mb-3 complete-note-cont">
                <p>
                  <strong>Note:</strong> Once completed, you won't be able to
                  add more notes this consultation session.
                </p>
              </div>

              {(() => {
                if (!hasDrafts && !hasOutstandingActions) return null;

                return (
                  <div className="space-y-3">
                    {/* ✅ Outstanding Actions */}
                    {hasOutstandingActions && (
                      <div
                        className={`rounded-lg p-3 transition-colors duration-300 ${
                          darkMode
                            ? "bg-orange-900/50 border border-orange-600"
                            : "bg-orange-50 border border-orange-300"
                        }`}
                      >
                        <div className="flex items-start gap-2">
                          <span className="mt-0.5">⚠️</span>
                          <div className="flex-1">
                            <p
                              className={`text-sm font-semibold mb-1 transition-colors duration-300 ${
                                darkMode ? "text-orange-300" : "text-orange-800"
                              }`}
                            >
                              Outstanding appointment actions
                            </p>

                            <p
                              className={`text-sm mb-3 transition-colors duration-300 ${
                                darkMode ? "text-orange-400" : "text-orange-700"
                              }`}
                            >
                              {outstandingActions} of {total} treatment plan
                              action
                              {total !== 1 ? "s" : ""}{" "}
                              {outstandingActions === 1 ? "has" : "have"} not
                              been ticked off.
                            </p>

                            <label className="flex items-start gap-2 cursor-pointer">
                              <input
                                type="checkbox"
                                className="mt-0.5 accent-orange-500"
                                checked={appointmentActionsConfirmed}
                                onChange={(e) =>
                                  setAppointmentActionsConfirmed(
                                    e.target.checked,
                                  )
                                }
                              />
                              <span
                                className={`text-sm transition-colors duration-300 ${
                                  darkMode
                                    ? "text-orange-300"
                                    : "text-orange-800"
                                }`}
                              >
                                I understand that these actions have not been
                                completed
                              </span>
                            </label>
                          </div>
                        </div>
                      </div>
                    )}

                    {/* ✅ Drafts */}
                    {hasDrafts && (
                      <div
                        className={`rounded-lg p-3 transition-colors duration-300 ${
                          darkMode
                            ? "bg-amber-900/50 border border-amber-600"
                            : "bg-amber-50 border border-amber-300"
                        }`}
                      >
                        <div className="flex items-start gap-2">
                          <span className="mt-0.5">⚠️</span>
                          <div className="flex-1">
                            <p
                              className={`text-sm font-semibold mb-1 transition-colors duration-300 ${
                                darkMode ? "text-amber-300" : "text-amber-800"
                              }`}
                            >
                              You have unsaved drafts
                            </p>
                            <p
                              className={`text-sm mb-3 transition-colors duration-300 ${
                                darkMode ? "text-amber-400" : "text-amber-700"
                              }`}
                            >
                              Some actions in this consultation are still in
                              draft and will be lost if you complete now.
                            </p>
                            <label className="flex items-start gap-2 cursor-pointer">
                              <input
                                type="checkbox"
                                className="mt-0.5 accent-amber-500"
                                checked={draftLossConfirmed}
                                onChange={(e) =>
                                  setDraftLossConfirmed(e.target.checked)
                                }
                              />
                              <span
                                className={`text-sm transition-colors duration-300 ${
                                  darkMode ? "text-amber-300" : "text-amber-800"
                                }`}
                              >
                                I understand that unsaved draft actions will be
                                lost
                              </span>
                            </label>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                );
              })()}

              <div className="complete-modal-btns">
                <button
                  className="btn-outline"
                  onClick={() => setShowCompletionModal(false)}
                >
                  Continue
                </button>
                <button
                  onClick={deleteActiveConsultation}
                  className="btn-delete"
                >
                  <FiTrash2 className="icon" />
                  Delete
                </button>
                <button
                  className={`btn-primary ${
                    isCompleteDisabled ? "opacity-50 cursor-not-allowed" : ""
                  }`}
                  onClick={handleUpdateStatus}
                  disabled={isCompleteDisabled}
                >
                  <Check className="icon" />
                  Complete
                </button>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
